<template>
    <a-modal :open="visible" title="新建分类" @ok="submitForm" @cancel="$emit('cancel')" :confirm-loading="isSubmitting"
        ok-text="创建分类" cancel-text="取消">
        <a-form :model="formData" layout="vertical" ref="formRef">
            <a-form-item label="分类名称" name="name" :rules="[{ required: true, message: '请输入分类名称' }]">
                <a-input v-model:value="formData.name" placeholder="请输入分类名称" :maxlength="50" show-count />
            </a-form-item>
            <a-form-item label="分类描述" name="description">
                <a-textarea v-model:value="formData.description" placeholder="请输入分类描述（可选）" :maxlength="200" :rows="3"
                    show-count />
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<script>
import { message } from 'ant-design-vue'
import supabaseCategoryService from '../../services/supabaseCategoryService.js'

export default {
    name: 'CreateCategoryModal',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        existingCategories: {
            type: Array,
            default: () => []
        }
    },
    emits: ['cancel', 'success'],
    data() {
        return {
            isSubmitting: false,
            formData: {
                name: '',
                description: ''
            }
        }
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                // 重置表单
                this.formData = {
                    name: '',
                    description: ''
                }
                this.$nextTick(() => {
                    this.$refs.formRef?.clearValidate()
                })
            }
        }
    },
    methods: {
        async submitForm() {
            try {
                // 验证表单
                await this.$refs.formRef.validate()

                const name = this.formData.name.trim()
                if (!name) {
                    message.error('请输入分类名称')
                    return
                }

                // 检查分类是否已存在
                const existingCategory = this.existingCategories.find(cat => cat.name === name)
                if (existingCategory) {
                    message.warning('分类已存在')
                    return
                }

                this.isSubmitting = true

                // 创建分类
                const newCategory = await supabaseCategoryService.create({
                    name: this.formData.name.trim(),
                    description: this.formData.description.trim() || null
                })

                message.success('分类创建成功！')
                this.$emit('success', newCategory)

            } catch (error) {
                console.error('创建分类失败:', error)
                message.error('创建分类失败：' + error.message)
            } finally {
                this.isSubmitting = false
            }
        }
    }
}
</script>